import React, { useState } from "react";
import { useInventarioInicialActualizado } from "../../../hooks/useInventarioInicialActualizado.js";

// Componentes
import TituloModulo from "../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import InventarioCard from "../tarjetaInventario/inventarioCard.js";
import BotonAccion from "../../../componentsUI/formularios/button/BotonAction.js";

import "../itemsActualizados/itemLista.css";

export default function ListaItemsActualizados() {
  const { inventarioInicial, loading, recargarDesdeBD } =
    useInventarioInicialActualizado();

  const [cardAbierta, setCardAbierta] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState("disponible");

  console.log("Component ListaItemsActualizados cargado:", inventarioInicial);

  if (loading) return <div>Cargando...</div>;

  const inventarioInicialFiltrado = inventarioInicial.filter((item) =>
    filtroEstado === "disponible"
      ? item.bloqueado === false
      : item.bloqueado === true,
  );

  return (
    <div>
      <TituloModulo titulo="Inventario Aprobado" />
      <div className="acciones-filtro">
        <BotonAccion onClick={recargarDesdeBD}>Cargar Inventario</BotonAccion>
        <BotonAccion onClick={() => setFiltroEstado("disponible")}>
          Consultar Pendientes
        </BotonAccion>

        <BotonAccion onClick={() => setFiltroEstado("bloqueado")}>
          Consultar Aprobados
        </BotonAccion>
      </div>
      <div className="contenedor-lista">
        {inventarioInicialFiltrado.map((item) => (
          <InventarioCard
            key={item.id}
            inventario={item}
            abierta={cardAbierta === item.id}
            onToggle={() =>
              setCardAbierta(cardAbierta === item.id ? null : item.id)
            }
          />
        ))}
      </div>
    </div>
  );
}
